import {
  IConfiguration,
  PatientProfileUpdateKinds,
} from "../../domain/configuration";

export class DefaultConfigurationFactory {
  static create(): IConfiguration {
    return {
      restriction: {
        user: {
          aiPhrase: {
            isEnable: false,
            user: {
              isEnable: false,
              allowed: [],
            },
            profession: {
              isEnable: false,
              allowed: [],
            },
          },
        },
      },
      behavior: {
        document: {
          editor: {
            shouldConfirmToLeavePage: true,
            confirmMessageToLeavePage: "編集中の文書を破棄してもよろしいですか？",
            confirmMessageToCloseWindow: "編集中の文書を破棄してもよろしいですか？",
            closeWindowConfirmation: {
              buttons: {
                confirmation: {
                  name: "破棄する"
                },
                cancellation: {
                  name: "中止する",
                },
              },
            },
            objectLazyDrawer: {
              initialDrawItemMax: 10000,
              intervalToDrawItemAsMsec: 1000,
              itemCountPerDraw: 100,
            },
            patientProfile: {
              // とりあえずは徳島の設定に合わせたつもり
              updateKind: PatientProfileUpdateKinds.AutoRegister,
              isEnable: false,
              isEditable: false,
            },
            hisInformationUpdate: {
              autoUpdateOnEditStart: {
                direct: false,
                workflow: false,
              },
              shouldUpdateEmptyObjectOnlyOnEditStart: {
                direct: false,
                workflow: false,
              },
              shouldUpdateAllHisItemsInExtraSectionWhenQuote: {
                direct: false,
                workflow: false,
              },
            },
            hisInformationUpdateMenu: {
              shouldShowUpdateEmptyObjectOnlyButton: false,
            },
            hisInformationSelector: {
              departmentFilter: {
                isEnable: false,
              },
              displayCountPerPage: 50,
              defaultSort: {
                disease: {
                  key: "",
                  isDescending: false,
                },
                hospitalization: {
                  key: "",
                  isDescending: false,
                },
                operation: {
                  key: "",
                  isDescending: false,
                },
              },
            },
            userDefinition: {
              displayCountPerPage: 100,
              filter: {
                default: {
                  shouldDistinguishCharacterWidth: true,
                }
              }
            },
            handles: {
              resize: {
                modifierKeyAssign: {
                  shift: "aspectRatioFixed",
                  control: "standard",
                  alt: "standard",
                },
              },
              size: {
                width: 10,
                height: 10,
              },
            },
            grid: {
              width: 10,
              height: 10,
            },
            extraPageAdditionAtInitialization: {
              isEnable: false,
              isTargetOnly: false,
              targets: [],
            },
            chainedObjectUpdation: {
              overflow: {
                max: 1000,
                level: "warning",
              }
            },
            externalScript: {
              shouldExecuteAsBatch: false,
              shouldExecuteAsStackedRequest: false,
              executeIntervalMilliSeconds: 500,
              executingDialogPollingIntervalMilliSeconds: 300,
            },
            objectLocator: {
              minSize: {
                width: 10,
                height: 10,
              },
            },
            imageDropper: {
              isEnable: true,
              sizeLimitation: {
                isEnable: false,
                maxSize: {
                  width: 200,
                  height: 200,
                },
              },
            },
            imageEditor: {
              claioSchema: {
                isEnable: true,
              },
              trimming: {
                isEnable: false,
              },
            },
            eraser: {
              isEnable: true,
              stackMaxSize: 5,
              defaultStrokeSize: 12,
              strokeSizes: [
                {
                  label: "大",
                  size: 16,
                },
                {
                  label: "中",
                  size: 12,
                },
                {
                  label: "小",
                  size: 8,
                },
              ]
            },
            shouldConfirmCalculationErrorToRegisterDocument: false,
            // コンテンツに関する設定はここに集約.将来的にタブの表示順が追加になった場合もpriorityを追加する等で対応する事.
            contents: {
              edit: {
                textStyle: {
                  fontFamily: {
                    isEnable: false,
                  },
                },
                selector: {
                  drawModeSelector: {
                    isEnable: true,
                    defaultShouldDrawEditStyle: true,
                  },
                  transparentSelector: {
                    isEnable: true,
                  },
                  freeInputSelector: {
                    isEnable: true,
                  },
                },
              },
              clipboard: {
                isEnable: false,
              },
              externalImage: {
                isEnable: false,
                name: "外部連携画像",
                displayCountPerPage: 20,
              },
              claio: {
                isEnable: false,
                name: "画像",
                shouldShowTree: false,
                edit: {
                  isEnable: true,
                },
                shouldFilterImagesByOrderNo: false,
                filters: {
                  orderNo: {
                    isEnable: false,
                  },
                  shouldPreferTodayImage: false,
                },
                preview: {
                  shouldDisplayActualSize: false,
                  shouldResizeFitImage: true,
                  height: 326,
                },
                displayCountPerPage: 20,
                shouldOrderByAscending: false,
                imageViewer: {
                  application: "claio",
                },
              },
              ocojo: {
                isEnable: false,
                name: "デジカメ画像",
                displayCountPerPage: 20,
              },
              schema: {
                isEnable: false,
                name: "シェーマ",
                shouldExecuteCNoteSchema: false,
                displayCountPerPage: 20,
                shouldExecuteWithDocumentDepartment: false,
              },
              documentView: {
                previewWindow: {
                  isEnable: false,
                },
                shouldCloseAfterQuotation: false,
              },
              fixedPhrase: {
                defaultSelectedTab: "user",
                commonDepartment: {
                  isEnable: false,
                },
                defaultFolderName: "",
              },
              aiPhrase: {
                isEnable: false,
                defaultSelectedTab: "user",
                commonDepartment: {
                  isEnable: false,
                },
                defaultFolderName: "",
                maxDurationDays: 60,
                neverHospitalizedDuration: {
                  shouldFill: true,
                  days: 30,
                },
                hospitalization: {
                  finder: {
                    lastDays: -1,
                  },
                },
                filters: {
                  departments: {
                    isEnable: false,
                  },
                  professions: {
                    isEnable: false,
                  },
                },
                recipe: {
                  name: "対象",
                  selectableRecipes: [
                    {
                      name: "標準",
                      alias: "",
                    },
                  ],
                },
              },
              aiTranslation: {
                isEnable: false,
                languages: [
                  "英語",
                  "日本語",
                  "北京語",
                  "広東語",
                  "韓国語",
                  "ドイツ語",
                ],
              },
            },
            panes: {
              left: {
                defaultSelectedTab: "edit",
                maxWidth: 370,
              },
              right: {
                defaultSelectedTab: "",
                automaticSwitchingWidth: 1317,
              },
            },
            pageNavigator: {
              visiblePageCount: 2,
              expandablePageCount: 2,
              pageCountToExpand: 2,
              isRightSide: true,
              focusIndicator: {
                borderWidth: 3,
              },
              expander: {
                areaWidth: 10,
                fontSize: 10,
              },
              expandedWidth: 300,
            },
            mischievousObjects: {
              createDate: {
                updateAndRollback: {
                  direct: false,
                  workflow: false,
                },
                shouldUpdateAndRollbackExceptFreeInputSelectedObject: false,
              },
              hospitalization: {
                shouldApplyBySubName: true,
                shouldValidateSubNameFormat: true,
                targetSubNameFormat: "^【入院[0-9０-９]+】$",
                shouldSelectHospitalizationInitialItemHospitalizedOnly: false,
              },
              disease: {
                shouldApplyBySubName: true,
                shouldValidateSubNameFormat: true,
                targetSubNameFormat: "^【通院[0-9０-９]+】$",
              },
              externalData: {
                shouldExeucuteWhenHisInformationManualUpdate: false,
              },
              doctor: {
                fillAutomatically: {
                  direct: false,
                  workflow: false,
                },
              },
            },
            calculationMenu: {
              isEnable: false,
            },
            menu: {
              registerAsTemporaryAndPrintWithWatermark: {
                name: "一時保存\n・印刷(透かし)",
                isEnable: false,
              },
              registerAsTemporaryAndPrint: {
                name: "一時保存\n・印刷",
              },
              registerAsTemporary: {
                name: "一時保存",
              },
              registerAndPrint: {
                name: "登録・印刷",
              },
              registerAndPrintWithDialog: {
                name: "登録\n・印刷(選択)",
                isEnable: false,
              },
              register: {
                name: "登録",
              },
              printWithoutRegistration: {
                name: "印刷",
              },
            },
            notifications: {
              registerAsTemporary: {
                message: "",
              },
            },
            designatedDoctorNumber: {
              isEnable: true,
              shouldSetWhiteSpaceIfEmpty: false,
            },
            registerer: {
              instantCloser: {
                isEnable: false,
                waitTimeAsMsec: 3000,
                notification: {
                  isEnable: false,
                  message: "$WAITTIMEASSEC$秒後に自動的に画面を閉じます.",
                  delayAsMsec: 100,
                },
              },
              allPagesEditValidator: {
                isEnable: false,
              },
              shouldPrintSpecifiedSectionAtFirstRegistration: {
                direct: true,
                workflow: false,
              },
              postRegistration: {
                applications: [],
              },
            },
            deleter: {
              postDeletion: {
                applications: [],
              },
            },
            validator: {
              textLength: {
                isError: true,
              },
              urls: [],
              mark: {
                shouldShowEmptyAlertMarkOnEditStart: false,
              },
            },
            injector: {
              urls: [],
            },
            conflict: {
              editConfirmation: {
                isEnable: true,
              },
              editTokenManagement: {
                isEnable: true,
              },
              createConfirmation: {
                isEnable: true,
              },
              createTokenManagement: {
                isEnable: true,
              },
              alert: {
                message: "本当に$action$しますか？",
                color: "#362F2F",
                isBold: false,
              },
            },
            formatUpdate: {
              isEnable: true,
            },
            objects: {
              shouldHideOutsidePage: false,
              shouldTransformSideLocatedObjectsByRelayout: false,
              richTextBox: {
                tabReplacementSpacesCount: 1,
                maxTextLength: 10000,
                adjustedHeightMagnification: 2,
                adjustedHeightMargin: 2000,
              },
              rangeOfMotion: {
                orderOfObjects: "official",
              },
              sign: {
                signTablet: {
                  isEnable: false,
                },
              },
            },
            newObjects: {
              shouldShowInvisibleGroup: false,
              NewArrowLine: {
                source: {
                  type: "Line",
                  isVisible: true,
                  printVisible: true,
                  previewVisible: true,
                  color: "#000000",
                  state: 1,
                  thickness: 2,
                  arrowState: 3,
                  isAdditional: true,
                  isDeleted: false,
                },
              },
              NewBoxLine: {
                source: {
                  type: "Rect",
                  isVisible: true,
                  printVisible: true,
                  previewVisible: true,
                  width: 20,
                  height: 20,
                  color: "#000000",
                  state: 1,
                  thickness: 2,
                  backColor: "#000000",
                  textureState: 0,
                  additionalTextureState: 0,
                  isAdditional: true,
                  isDeleted: false,
                },
                locator: {
                  shouldStamp: false,
                },
              },
              NewCircle: {
                source: {
                  type: "Ellipse",
                  isVisible: true,
                  printVisible: true,
                  previewVisible: true,
                  width: 20,
                  height: 20,
                  color: "#000000",
                  state: 1,
                  thickness: 2,
                  backColor: "#000000",
                  textureState: 0,
                  additionalTextureState: 0,
                  isAdditional: true,
                  isDeleted: false,
                },
                locator: {
                  shouldStamp: false,
                },
              },
              NewCross: {
                source: {
                  type: "Cross",
                  isVisible: true,
                  printVisible: true,
                  previewVisible: true,
                  width: 20,
                  height: 20,
                  color: "#000000",
                  state: 1,
                  thickness: 2,
                  isAdditional: true,
                  isDeleted: false,
                },
                locator: {
                  shouldStamp: true,
                },
              },
              NewImage: {
                source: {
                  type: "MovableImage",
                  isVisible: true,
                  printVisible: true,
                  previewVisible: true,
                  isAdditional: true,
                  isDeleted: false,
                  isQuotable: true,
                  supportedQuotable: true,
                },
              },
              NewLine: {
                source: {
                  type: "Line",
                  isVisible: true,
                  printVisible: true,
                  previewVisible: true,
                  color: "#000000",
                  state: 1,
                  thickness: 2,
                  arrowState: 1,
                  isAdditional: true,
                  isDeleted: false,
                },
              },
              NewNewPage: {
                source: {
                  type: "NewPage",
                  isAdditional: true,
                  isDeleted: false,
                },
              },
              NewPolyline: {
                source: {
                  type: "FreeLine",
                  isVisible: true,
                  printVisible: true,
                  previewVisible: true,
                  color: "#000000",
                  state: 1,
                  thickness: 2,
                  isAdditional: true,
                  isDeleted: false,
                },
              },
              NewTag: {
                source: {
                  type: "MovableText",
                  isVisible: true,
                  printVisible: false,
                  previewVisible: false,
                  isAdditional: true,
                  isDeleted: false,
                  name: "",
                  textColor: "#000000",
                  textFontName: "ＭＳ ゴシック",
                  textFontSize: 14,
                  textLineHeight: 1.06,
                  textAlign: 1,
                  backColor: "#FFFFFF",
                  displayBackColor: null,
                  supportedFreeText: true,
                  enabledFreeText: true,
                  text: "",
                  emptyCheck: false,
                  nameGroupEmptyCheck: false,
                  alertGroup: null,
                  enabledAutoAdjustFontSize: true,
                  dataValidation: null,
                  isQuotable: true,
                  supportedQuotable: true,
                  adjustedTextFontSize: 14,
                  isDisplayBackColorSpecified: false,
                },
              },
              NewText: {
                source: {
                  type: "MovableText",
                  isVisible: true,
                  printVisible: true,
                  previewVisible: true,
                  isAdditional: true,
                  isDeleted: false,
                  name: "",
                  textColor: "#000000",
                  textFontName: "ＭＳ ゴシック",
                  textFontSize: 14,
                  textLineHeight: 1.06,
                  textAlign: 1,
                  backColor: "#FFFFFF",
                  displayBackColor: null,
                  supportedFreeText: true,
                  enabledFreeText: true,
                  text: "",
                  emptyCheck: false,
                  nameGroupEmptyCheck: false,
                  alertGroup: null,
                  enabledAutoAdjustFontSize: true,
                  dataValidation: null,
                  isQuotable: true,
                  supportedQuotable: true,
                  adjustedTextFontSize: 14,
                  isDisplayBackColorSpecified: false,
                },
              },
              NewTriangle: {
                source: {
                  type: "Triangle",
                  isVisible: true,
                  printVisible: true,
                  previewVisible: true,
                  width: 20,
                  height: 20,
                  color: "#000000",
                  state: 1,
                  thickness: 2,
                  backColor: "#000000",
                  textureState: 0,
                  additionalTextureState: 0,
                  isAdditional: true,
                  isDeleted: false,
                },
                locator: {
                  shouldStamp: true,
                },
              },
              NewInvisibleArrowLine: {
                source: {
                  type: "Line",
                  isVisible: true,
                  printVisible: false,
                  previewVisible: false,
                  color: "#000000",
                  state: 1,
                  thickness: 2,
                  arrowState: 3,
                  isAdditional: true,
                  isDeleted: false,
                },
              },
              NewInvisibleBoxLine: {
                source: {
                  type: "Rect",
                  isVisible: true,
                  printVisible: false,
                  previewVisible: false,
                  width: 20,
                  height: 20,
                  color: "#000000",
                  state: 1,
                  thickness: 2,
                  backColor: "#000000",
                  textureState: 0,
                  additionalTextureState: 0,
                  isAdditional: true,
                  isDeleted: false,
                },
                locator: {
                  shouldStamp: false,
                },
              },
              NewInvisibleCircle: {
                source: {
                  type: "Ellipse",
                  isVisible: true,
                  printVisible: false,
                  previewVisible: false,
                  width: 20,
                  height: 20,
                  color: "#000000",
                  state: 1,
                  thickness: 2,
                  backColor: "#000000",
                  textureState: 0,
                  additionalTextureState: 0,
                  isAdditional: true,
                  isDeleted: false,
                },
                locator: {
                  shouldStamp: false,
                },
              },
              NewInvisibleCross: {
                source: {
                  type: "Cross",
                  isVisible: true,
                  printVisible: false,
                  previewVisible: false,
                  width: 20,
                  height: 20,
                  color: "#000000",
                  state: 1,
                  thickness: 2,
                  isAdditional: true,
                  isDeleted: false,
                },
                locator: {
                  shouldStamp: true,
                },
              },
              NewInvisibleLine: {
                source: {
                  type: "Line",
                  isVisible: true,
                  printVisible: false,
                  previewVisible: false,
                  color: "#000000",
                  state: 1,
                  thickness: 2,
                  arrowState: 1,
                  isAdditional: true,
                  isDeleted: false,
                },
              },
              NewInvisiblePolyline: {
                source: {
                  type: "FreeLine",
                  isVisible: true,
                  printVisible: false,
                  previewVisible: false,
                  color: "#000000",
                  state: 1,
                  thickness: 2,
                  isAdditional: true,
                  isDeleted: false,
                },
              },
              NewInvisibleTriangle: {
                source: {
                  type: "Triangle",
                  isVisible: true,
                  printVisible: false,
                  previewVisible: false,
                  width: 20,
                  height: 20,
                  color: "#000000",
                  state: 1,
                  thickness: 2,
                  backColor: "#000000",
                  textureState: 0,
                  additionalTextureState: 0,
                  isAdditional: true,
                  isDeleted: false,
                },
                locator: {
                  shouldStamp: true,
                },
              }
            },
            sign: {
              newObjects: {
                NewPen: {
                  source: {
                    type: "FreeLine",
                    isVisible: true,
                    printVisible: true,
                    previewVisible: true,
                    color: "#FF0000",
                    state: 1,
                    thickness: 5,
                    isAdditional: true,
                    isDeleted: false,
                  },
                }
              }
            },
            previewMenu: {
              printing: {
                isEnable: true,
              },
              shouldShowPrintPreview: false,
            },
            documentAttributes: {
              createdDate: {
                isEnable: true,
              },
              department: {
                shouldUpdateDepartmentHisObjectsWhenChanged: false,
              },
              orderUser: {
                shouldUpdateOnEditStart: true,
              },
              attendingUser: {
                shouldUpdateOnEditStart: true,
              },
              scale: {
                defaultScaleAsPercentage: null,
              }
            },
            externalMenus: [],
            externalTemplates: {
              shouldSetCopiedIdWhenTemplateCopied: true,
            },
            quotation: {
              isOtherPatientDocumentQuotable: false,
              shouldApplyValueToEmptyObjectOnly: false,
              shouldCopyAllAdditionalItems: {
                byObjectName: false,
                byObjectId: true,
              },
              shouldCopyExtraSections: {
                byObjectName: false,
                byObjectId: true,
              },
              formatFilter: {
                isEnable: false,
              },
            },
            preview: {
              shouldPrintWatermarkForcibly: false,
            },
            naturalText: {
              isEnable: false,
            },
            multiple: {
              isMultiplePatientDocumentEditable: true,
            },
            singleEntry: {
              isEnable: false,
            },
            departmentGroup: {
              shouldIgnoreDepartmentGroupFilter: false,
            },
            shouldConfirmRegisterRevisedChainDocuments: false,
            temporaryNote: {
              shouldShowInputDialogBeforeRegisterAsTemporary: true,
              shouldShowTemporaryNoteOnEditStart: true,
            },
            management: {
              isEnable: false,
              shouldSkipWhenTemporaryRegistration: true,
              restriction: {
                professionCodes: [],
              },
              approver: {
                professionCodes: [],
                enableAutoSelection: false,
              }
            },
            collaboration: {
              shouldRegisterCollaborationParameter: false,
            },
            injectedData: {
              isEnable: false,
            },
          },
          viewer: {
            isMajorActionInstant: true,
            menu: {
              isEnable: false,
              quote: {
                isEnable: true,
              },
              note: {
                isEnable: true,
              },
            },
            printing: {
              shouldPrintDefaultCopies: false,
            },
            externalMenus: [],
            pdfRendering: {
              shouldRenderUnmanagedDocumentByPlugin: false, // MEDI-Papyrus移行案件以外ではfalseの方がUI統一の観点からよいので既定値はfalse.(ClaioReport案件は結構あるので.)
            },
          },
          list: {
            infiniteLoader: {
              rowCount: 30,
            },
            menu: {
              create: {
                isEnable: true,
              },
              quote: {
                isEnable: true,
              },
              quoteAutomatically: {
                isEnable: false,
              },
              copy: {
                isEnable: false,
              },
              previewLikeEditing: {
                isEnable: false,
              },
              externalMenus: [],
              patientExternalMenus: [],
              documentPublishedHistory: {
                shouldShowPrinterName: false,
              },
            },
            sort: {
              default: {
                isEnable: false,
                columnKey: "",
                isDescending: false
              },
            },
            selector: {
              defaultSelectedTab: "card",
              style: {
                list: {
                  columns: [
                    "contentDateTime",
                    "patientNo",
                    "patientName",
                    "department",
                    "documentName",
                    "companyName",
                    "createStaffName",
                    "orderUserName",
                    "attendingUserName",
                    "createdDateTime",
                    "published",
                    "publishedCount",
                    "describedMethod",
                    "note",
                    "edition",
                    "id",
                  ],
                }
              }
            },
            finder: {
              duration: {
                default: {
                  isDocument: false,
                },
              },
              conditionIndication: {
                format: {
                  max: 3,
                },
              },
              collapse: {
                shouldShrinkAutomatically: false,
              },
              notification: {
                limitExceed: {
                  isEnable: false,
                  message: "検索結果の件数が最大指定件数を超過しました。"
                },
              },
            },
            patientSpecified: {
              finder: {
                duration: {
                  default: {
                    isDocument: true,
                  },
                },
              },
            },
            presetFilters: {},
            csv: {
              isEnable: false,
            },
            printing: {
              shouldPrintDefaultCopies: false,
            },
          },
          registerNewDocuments: {
            his: {
              emptyKeys: [],
            },
          },
          entities: {
            date: {
              formats: [
                {
                  label: "年月日(西暦)",
                  format: "Y 年 M 月 D 日",
                  dayOfWeekFormatPostfix: " ($ddd$)",
                  yearFormat: "Y 年",
                  yearMonthFormat: "Y 年 M 月",
                },
                {
                  label: "年月日(和暦年号あり)",
                  format: "$JJJ$ $Y$ 年 M 月 D 日",
                  dayOfWeekFormatPostfix: " ($ddd$)",
                  yearFormat: "$JJJ$ $Y$ 年",
                  yearMonthFormat: "$JJJ$ $Y$ 年 M 月",
                },
                {
                  label: "年月日(和暦年号なし)",
                  format: "$Y$ 年 M 月 D 日",
                  dayOfWeekFormatPostfix: " ($ddd$)",
                  yearFormat: "$Y$ 年",
                  yearMonthFormat: "$Y$ 年 M 月",
                },
                {
                  label: "年/月/日(西暦)",
                  format: "Y / M / D",
                  dayOfWeekFormatPostfix: "($ddd$)",
                  yearFormat: "Y",
                  yearMonthFormat: "Y / M",
                },
                {
                  label: "年/月/日(和暦年号記号)",
                  format: "$J$$Y$ / M / D",
                  dayOfWeekFormatPostfix: "($ddd$)",
                  yearFormat: "$J$$Y$",
                  yearMonthFormat: "$J$$Y$ / M",
                },
                {
                  label: "年.月.日(西暦)",
                  format: "Y.M.D",
                  dayOfWeekFormatPostfix: "($ddd$)",
                  yearFormat: "Y",
                  yearMonthFormat: "Y.M",
                },
                {
                  label: "年.月.日(和暦年号記号)",
                  format: "$J$$Y$.M.D",
                  dayOfWeekFormatPostfix: "($ddd$)",
                  yearFormat: "$J$$Y$",
                  yearMonthFormat: "$J$$Y$.M",
                },
                {
                  label: "年月(西暦)",
                  format: "Y 年 M 月",
                  dayOfWeekFormatPostfix: " ($ddd$)",
                  yearFormat: "Y 年",
                  yearMonthFormat: "Y 年 M 月",
                },
                {
                  label: "年月(和暦年号あり)",
                  format: "$JJJ$ $Y$ 年 M 月",
                  dayOfWeekFormatPostfix: " ($ddd$)",
                  yearFormat: "$JJJ$ $Y$ 年",
                  yearMonthFormat: "$JJJ$ $Y$ 年 M 月",
                },
                {
                  label: "年月(和暦年号なし)",
                  format: "$Y$ 年 M 月",
                  dayOfWeekFormatPostfix: " ($ddd$)",
                  yearFormat: "$Y$ 年",
                  yearMonthFormat: "$Y$ 年 M 月",
                },
                {
                  label: "年.月(和暦年号記号)",
                  format: "$J$$Y$.M",
                  dayOfWeekFormatPostfix: "($ddd$)",
                  yearFormat: "$J$$Y$",
                  yearMonthFormat: "$J$$Y$.M",
                },
                {
                  label: "月日",
                  format: "M 月 D 日",
                  dayOfWeekFormatPostfix: " ($ddd$)",
                  yearFormat: "Y 年",
                  yearMonthFormat: "Y 年 M 月",
                },
                {
                  label: "月/日",
                  format: "M / D",
                  dayOfWeekFormatPostfix: "($ddd$)",
                  yearFormat: "Y",
                  yearMonthFormat: "Y / M",
                },
                {
                  label: "和暦年号のみ",
                  format: "$JJJ$",
                  dayOfWeekFormatPostfix: " ($ddd$)",
                  yearFormat: "$JJJ$ $Y$ 年",
                  yearMonthFormat: "$JJJ$ $Y$ 年 M 月",
                },
                {
                  label: "和暦年号記号のみ",
                  format: "$J$",
                  dayOfWeekFormatPostfix: "($ddd$)",
                  yearFormat: "$J$$Y$",
                  yearMonthFormat: "$J$$Y$.M",
                },
                {
                  label: "カスタム書式",
                  format: "$MANUAL$",
                  dayOfWeekFormatPostfix: "($ddd$)",
                  yearFormat: "Y 年",
                  yearMonthFormat: "Y 年 M 月",
                },
              ],
            },
            time: {
              formats: [
                {
                  label: "時分(午前・午後)",
                  format: "$A$ hh 時 mm 分",
                  fuzzyFormat: "$A$ hh 時 ",
                },
                {
                  label: "時分(AM・PM)",
                  format: "A hh 時 mm 分",
                  fuzzyFormat: "A hh 時 ",
                },
                {
                  label: "時分(12時間)",
                  format: "hh 時 mm 分",
                  fuzzyFormat: "hh 時 ",
                },
                {
                  label: "時分(24時間)",
                  format: "HH 時 mm 分",
                  fuzzyFormat: "HH 時 ",
                },
                {
                  label: "時:分(AM・PM)",
                  format: "A hh : mm",
                  fuzzyFormat: "A hh : 00",
                },
                {
                  label: "時:分(12時間)",
                  format: "hh : mm",
                  fuzzyFormat: "hh : 00",
                },
                {
                  label: "時:分(24時間)",
                  format: "HH : mm",
                  fuzzyFormat: "HH : 00",
                },
              ],
              formatsIncludeSecond: [
                {
                  label: "時分秒(午前・午後)",
                  format: "$A$ hh 時 mm 分 ss 秒",
                  fuzzyFormat: "$A$ hh 時 ",
                },
                {
                  label: "時分秒(AM・PM)",
                  format: "A hh 時 mm 分 ss 秒",
                  fuzzyFormat: "A hh 時 ",
                },
                {
                  label: "時分秒(12時間)",
                  format: "hh 時 mm 分 ss 秒",
                  fuzzyFormat: "hh 時 ",
                },
                {
                  label: "時分秒(24時間)",
                  format: "HH 時 mm 分 ss 秒",
                  fuzzyFormat: "HH 時 ",
                },
                {
                  label: "時:分:秒(AM・PM)",
                  format: "A hh : mm : ss",
                  fuzzyFormat: "A hh : 00",
                },
                {
                  label: "時:分:秒(12時間)",
                  format: "hh : mm : ss",
                  fuzzyFormat: "hh : 00",
                },
                {
                  label: "時:分:秒(24時間)",
                  format: "HH : mm : ss",
                  fuzzyFormat: "HH : 00",
                },
              ],
            },
          },
          previewWindow: {
            parentWatchIntervalMilliSeconds: 3000,
          },
          processor: {
            executeIntervalMilliSeconds: 100,
            errorCloseIntervalMilliSeconds: 60000,
          },
          postPrinting: {
            applications: [],
          },
        },
        format: {
          formatSet: {
            // フォーマットセットが有効か？
            isEnable: false,
            shouldOpenWindowsWithUrlScheme: false,
            tab: {
              commonDepartment: {
                isEnable: true,
              },
              department: {
                isEnable: true,
                isDepartmentSelectable: true,
              },
              user: {
                isEnable: false,
              },
            },
          },
          selector: {
            defaultSelectedTab: null,
            tab: {
              all: {
                isEnable: true,
              },
              commonDepartment: {
                isEnable: true,
              },
              department: {
                isEnable: true,
                isDepartmentSelectable: true,
              },
              user: {
                isEnable: true,
              },
            },
            shouldExpandTreeAutomatically: false,
            collapse: {
              shouldShrinkAutomatically: false,
            },
            shouldShowDirectoryPath: true,
          },
          multiSelector: {
            max: 100,
            addition: {
              max: 100,
            }
          },
          referenceFile: {
            shouldShowPdfByClientViewer: true,
            forceEnableOpenTypeFontFace: false,
          },
          favorite: {
            defaultFolderName: null,
          },
          option: {
            masterCodePrefixes: [
              { prefix: "LIAJ" },
              { prefix: "GIAJ" },
              { prefix: "JIDIC" },
              { prefix: "FNLIA" },
              { prefix: "FJCC" },
              { prefix: "JAKYOSAI" },
              { prefix: "COOP" },
              { prefix: "kseikyo" },
              { prefix: "ZRS" },
            ]
          },
          list: {
            menu: {
              documentList: {
                isEnable: true,
              },
              externalMenus: [],
            },
          },
          editor: {
            sharing: {
              isEnable: false,
            },
          },
        },
        patient: {
          feature: {
            isEnable: true,
          },
          fixed: {
            isEnable: false,
            code: "00000001",
          },
          id: {
            isNumberOnly: true,
          },
          finder: {
            // 患者選択画面で確認表示をするかどうか？
            shouldConfirmFoundPatient: false,
            name: {
              isEnable: true,
            },
          },
          otherId: {
            isEnable: false,
          }
        },
        departmentGroup: {
          feature: {
            isEnable: false,
          },
          scope: {
            isEnable: false,
          },
        },
        department: {
          feature: {
            isEnable: true,
          },
          fixed: {
            isEnable: false,
            code: "1",
          },
          multiSelector: {
            max: 100,
            addition: {
              max: 100,
            }
          },
        },
        profession: {
          feature: {
            isEnable: true,
          },
        },
        localhost: {
          // localhost連携が有効か？
          isEnable: false,
          // URLschemeのURLのprefix.
          schemeUrlPrefix: "documaker://",
          // HTTP通信のURLのprefix.
          // 空の場合はapiサーバに接続する.
          // http://localhost:82
          // http://localhost:8080
          httpUrlPrefix: "",
          application: {
            // 外部アプリケーション連携が有効か？
            isEnable: false,
          },
          internalScript: {
            // 内部スクリプト実行が有効か？
            isEnable: false,
            scripts: {
              convertReplacer: {
                isEnable: true,
                pathExpression: "(^|\\\\)ConvertReplacer\\.exe$",
              },
              imageDateTimeGetter: {
                isEnable: true,
                pathExpression: "(^|\\\\)ImageDateTimeGetter\\.exe$",
              },
              valueConverter: {
                isEnable: true,
                pathExpression: "(^|\\\\)ValueConverter\\.exe$",
              },
              externalSystemValueGetter: {
                isEnable: true,
                pathExpression: "(^|\\\\)ExternalSystemValueGetter\\.exe$",
              },
              professionGetter: {
                isEnable: true,
                pathExpression: "(^|\\\\)ProfessionGetter\\.exe$",
              },
              generalReplacer: {
                isEnable: false,
                pathExpression: "(^|\\\\)GeneralReplacer\\.exe$",
              },
              currentDateTimeGetter: {
                isEnable: true,
                pathExpression: "(^|\\\\)CurrentDateTimeGetter\\.exe$",
              },
            },
          },
          externalScript: {
            // 外部処理の結果を待つ処理のタイムアウト設定
            responseWaiting: {
              intervalMilliSeconds: 300,
              maxCount: 200,
            },
            webApplication: {
              closeWaitMilliSeconds: 10,
              hisDataPicker: {
                isEnable: false,
                pathExpression: "(^|\\\\)HisDataPickerForWeb\\.exe$",
              },
              introductionSelector: {
                isEnable: false,
                pathExpression: "(^|\\\\)IntroductionSelectorForWeb\\.exe$",
              },
            },
          },
          printer: {
            // 印刷連携が有効か？
            isEnable: false,
          },
          clipboard: {
            // clipboard連携が有効か？
            isEnable: false,
            // clipboard連携サービスの実行周期.(msec)
            serviceIntervalAsMsec: 1000,
          },
          clippedImageRegisterer: {
            isEnable: true,
            responseWaiting: {
              intervalMilliSeconds: 500,
              maxCount: 20,
            },
          },
          window: {
            opener: {
              isEnable: false,
              restrictions: {
                path: {
                  isEnable: false,
                  paths: [],
                },
                browser: {
                  isEnable: true,
                }
              },
            },
          },
        },
        user: {
          finder: {
            doctorProfessionCodes: [],
            shouldShowProjectTeamSelector: false,
            shouldShowDesignatedDoctorSelector: false,
            shouldShowBelongedAllDepartmentsSelector: false,
            shouldFilterBelongedAllDepartmentsSelector: false,
            shouldFilterDepartmentUsersByMainDepartment: false,
            shouldShowPhoneNumber: false,
          },
          multiSelector: {
            max: 100,
            addition: {
              max: 100,
            }
          },
        },
        reception: {
          isEnable: true,
          editor: {
            shouldConfirmToLeavePage: true,
            shouldRegisterNewWorkflowDocumentsWhenNewReceptionRegistered: true,
            shouldRegisterNewRequestSheetWhenNewReceptionRegistered: false,
            confirmMessageToLeavePage: "入力中の依頼情報が破棄されますがよろしいですか？",
            confirmMessageToCloseWindow: "入力中の依頼情報が破棄されますがよろしいですか？",
            closeWindowConfirmation: {
              buttons: {
                confirmation: {
                  name: "破棄する",
                },
                cancellation: {
                  name: "中止する",
                },
              },
            },
            conflict: {
              createConfirmation: {
                isEnable: true,
              },
              createTokenManagement: {
                isEnable: true,
              },
            }
          },
          list: {
            finder: {
              patient: {
                history: {
                  isEnable: true,
                  maxCount: 5,
                },
              },
            },
            panes: {
              automaticSwitchingWidth: 1366,
            },
            selector: {
              defaultSelectedTab: "card",
            },
            tabs: {
              departmentTodo: {
                isEnable: true,
              },
            },
            detailDialog: {
              panes: {
                automaticSwitchingWidth: 566,
              }
            },
            sort: {
              default: {
                card: {
                  isEnable: false,
                  columnKey: "",
                  isDescending: false,
                },
                list: {
                  isEnable: false,
                  columnKey: "",
                  isDescending: false,
                },
              },
            },
            filter: {
              isEnable: false,
              filters: [],
            },
            menu: {
              adminExternalMenus: [],
            },
          },
        },
        authentication: {
          logout: {
            isEnable: true,
          },
          login: {
            shouldSelectDepartment: false,
            shouldSelectDepartmentAutomatically: true,
            shouldSkipDepartmentAutoSelectionIfDepartmentsIsEmpty: false,
            shouldSelectDepartmentGroupByLoginDepartmentAutomatically: false,
          },
        },
        closer: {
          isEnable: true,
        },
        collaboration: {
          claio: {
            imageName: "Claio画像",
          },
          externalImage: {
            imageName: "外部連携画像",
          },
          schema: {
            imageName: "シェーマ",
          },
          ocojo: {
            imageName: "デジカメ画像",
          },
          scan: {
            shouldVerifyBeforeEdit: false,
            shouldVerifyBeforeDelete: false,
            shouldVerifyOnEditStart: false,
            scannedDocumentEditConfirmMessage: "この文書はスキャン取込済みですが、編集を開始してもよろしいですか？",
          },
        },
        header: {
          message: {
            isEnable: false,
            displayText: null,
            styleProperties: {
              textAlign: "right",
              fontSize: "12px",
            },
          },
        },
        configuration: {
          isEnable: false,
        },
        fixedPhrase: {
          shouldExpandTreeAutomatically: false,
        },
        setting: {
          isEnable: true,
          shouldShowTreeNodeKey: true,
        },
        wizard: {
          editor: {
            shouldShowNotImplemented: true,
          },
        },
        emailAccount: {
          isEnable: false,
        },
      },
      style: {
        theme: "",
        panes: {
          rightSide: {
            shouldMainContentsPlaceBottom: false,
          },
        },
        document: {
          editor: {
            objects: {
              barcode: {
                default: {
                  backgroundColor: "#FF9999",
                  borderColor: "#FFFFFF",
                },
              },
              calculate: {
                default: {
                  backgroundColor: "#CAFDFD",
                  borderColor: "#CAFDFD",
                },
                calculation: {
                  backgroundColor: "#E6DDFF",
                  borderColor: "#E6DDFF",
                },
                dateComparison: {
                  backgroundColor: "#E6DDFF",
                  borderColor: "#E6DDFF",
                },
                conditional: {
                  backgroundColor: "#EFEEBA",
                  borderColor: "#EFEEBA",
                },
                datePeriod: {
                  backgroundColor: "#E6DDFF",
                  borderColor: "#E6DDFF",
                },
                timePeriod: {
                  backgroundColor: "#E6DDFF",
                  borderColor: "#E6DDFF",
                },
                foreground: {
                  isEnable: false,
                },
              },
              checkBox: {
                default: {    // 枠有時のスタイル.
                  backgroundColor: "#FFFFFF",
                  borderColor: "#000000",
                },
                borderless: { // 枠無時のスタイル.
                  backgroundColor: "#FFFFFF",
                  borderColor: "#000000",
                },
              },
              circleSelect: {
                default: {
                  backgroundColor: "transparent", // v1実装は透過固定.原則変更しない事.
                  borderColor: "#FF9999",
                },
              },
              comboBox: {
                // ComboBoxの背景色は印刷色と共通のため設定は持たない.(v1同様選択項目に設定されてる色に従う.)
                default: {
                  backgroundColor: "#FFCCCC", // ComboBoxの背景色は印刷色と同様に選択項目に設定されてる色を使う.(v1同等.)項目未選択時のみに利用される.
                  borderColor: "#000000",
                },
                mark: {
                  visibleObjectWidth: 50,
                },
                foreground: {
                  isEnable: false,
                },
              },
              date: {
                default: {
                  backgroundColor: "#CAFDFD",
                  borderColor: "#CAFDFD",
                },
                date: {
                  backgroundColor: "#CAFDFD",
                  borderColor: "#CAFDFD",
                },
                hisInformation: {
                  backgroundColor: "#FDFD7F",
                  borderColor: "#FDFD7F",
                },
                time: {
                  backgroundColor: "#CAFDFD",
                  borderColor: "#CAFDFD",
                },
                userDefinition: {
                  backgroundColor: "#FDFD7F",
                  borderColor: "#FDFD7F",
                },
                foreground: {
                  isEnable: false,
                },
              },
              externalData: {
                default: {
                  backgroundColor: "#CAFDFD",
                  borderColor: "#CAFDFD",
                },
                externalData: {
                  backgroundColor: "#FDFD7F",
                  borderColor: "#FDFD7F",
                },
                foreground: {
                  isEnable: false,
                },
              },
              externalProcess: {
                default: {
                  backgroundColor: "#C0C0C0",
                  borderColor: "#000000"
                },
              },
              image: {
                default: {
                  backgroundColor: "#CBFFCB",
                  borderColor: "#CBFFCB"
                },
                foreground: {
                  isEnable: false,
                },
              },
              sign: {
                default: {
                  backgroundColor: "#CBFFCB",
                  borderColor: "#CBFFCB"
                },
                foreground: {
                  isEnable: false,
                },
              },
              movableImage: {
                foreground: {
                  isEnable: false,
                },
              },
              movableTextBox: {
                default: {
                  backgroundColor: "#FFE4E1",
                  borderColor: "#FFE4E1",
                },
                mksTemplate: {
                  backgroundColor: "#FFFFFF",
                  borderColor: "#000000",
                },
                dynamicTemplate: {
                  backgroundColor: "#FFFFFF",
                  borderColor: "#000000",
                },
                notPrintable: {
                  backgroundColor: "#A4EC32",
                  borderColor: "#A4EC32",
                },
                related: {
                  backgroundColor: "#FDD8FD",
                  borderColor: "#FDD8FD",
                },
                foreground: {
                  isEnable: false,
                },
              },
              roll: {
                default: {
                  backgroundColor: "transparent", // Rollの背景色は常に透過.原則変更しない事.(v1同様.印刷は選択項目に設定されてる色に従う.)
                  borderColor: "#FDCA61",
                },
                foreground: {
                  isEnable: false,
                },
              },
              textBox: {
                default: {
                  backgroundColor: "#CAFDFD",
                  borderColor: "#CAFDFD",
                },
                hisInformation: {
                  backgroundColor: "#FDFD7F",
                  borderColor: "#FDFD7F",
                },
                notEditable: {  // v1挙動を再現できるよう印刷時塗りつぶし有無で別のスタイルを適用できるようにしている.原則変更しない事.
                  notFilledOnPrinting: {  // 印刷時透過してるものは透過しないと下に配置されるオブジェクトが欠けるケース有.(実際に徳大の「経過報告書（文書化なし）_」で下の円選択が欠ける.)原則変更しない事.(そういうフォーマット全て編集時背景色設定が透過色になってれば変えてもよい.)
                    backgroundColor: "transparent",
                    borderColor: "transparent",
                  },
                  filledOnPrinting: {     // 印刷時塗りつぶしてるものは塗りつぶさないと塗りつぶそうとした下のオブジェクトが見えるケース有.(実際に徳大の「文書作成依頼書」で担当名が重なって見える.)原則変更しない事.(そういうフォーマット全て編集時背景色設定が行われてれば変えてもよい.)
                    backgroundColor: "#FFFFFF",
                    borderColor: "#FFFFFF",
                  },
                },
                mksTemplate: {
                  backgroundColor: "#FFFFFF",
                  borderColor: "#000000",
                },
                dynamicTemplate: {
                  backgroundColor: "#FFFFFF",
                  borderColor: "#000000",
                },
                numericInputting: {
                  backgroundColor: "#CAFDFD",
                  borderColor: "#CAFDFD",
                },
                userDefinition: {
                  backgroundColor: "#FDFD7F",
                  borderColor: "#FDFD7F",
                },
                related: {
                  backgroundColor: "#FDD8FD",
                  borderColor: "#FDD8FD",
                },
                foreground: {
                  isEnable: false,
                },
              },
              rangeOfMotionTextBox: {
                default: {
                  backgroundColor: "#FFFFFF",
                  borderColor: "#FF0000",
                },
              },
              joinText: {
                default: {
                  backgroundColor: "#CAFDFD",
                  borderColor: "#CAFDFD",
                },
                joinText: {
                  backgroundColor: "#FDFD7F",
                  borderColor: "#FDFD7F",
                },
                foreground: {
                  isEnable: false,
                },
              },
              richTextBox: {
                default: {
                  backgroundColor: "#CCFF99",
                  borderColor: "#6464FF",
                },
                notPrintable: {
                  backgroundColor: "#A4EC32",
                  borderColor: "#A4EC32",
                },
                related: {
                  backgroundColor: "#FDD8FD",
                  borderColor: "#FDD8FD",
                },
                foreground: {
                  isEnable: true,
                },
              },
              stamp: {
                default: {
                  backgroundColor: "#FF9999",
                  borderColor: "#FFFFFF",
                },
              },
            },
            focusIndicator: {
              borderWidth: 3,
            },
            colorPallets: [
              "#FF0000",
              "#FFFF00",
              "#00FF00",
              "#00FFFF",
              "#0000FF",
              "#FF00FF",
              "#FFFFFF",
              "#000000",
            ],
            focusedObject: {
              shouldDrawForeground: true,
            }
          },
          list: {
            selector: {
              style: {
                unpublished: {
                  color: "#ff0000",
                },
                row: {
                  deleted: {
                    backgroundColor: "#fdf9f2",
                  },
                  temporary: {
                    backgroundColor: "#fdf9f2",
                  },
                },
                list: {
                  columns: {
                    ["*"]: {
                      padding: {
                        topAndBottom: 12,
                        leftAndRight: 0,
                      },
                      width: 150,
                      shouldWrap: true,
                      fontSize: 14,
                    },
                    ["contentDateTime"]: {
                      width: 120,
                    },
                    ["patientNo"]: {
                      width: 120,
                    },
                    ["patientName"]: {},
                    ["department"]: {},
                    ["documentName"]: {},
                    ["companyName"]: {},
                    ["createStaffName"]: {},
                    ["orderUserName"]: {},
                    ["attendingUserName"]: {},
                    ["createdDateTime"]: {
                      width: 120,
                    },
                    ["published"]: {
                      width: 100,
                    },
                    ["describedMethod"]: {
                      width: 140,
                    },
                    ["note"]: {
                      shouldWrap: false,
                    },
                    ["edition"]: {
                      width: 80,
                    },
                    ["id"]: {
                      width: 100,
                    },
                  },
                },
              },
            },
          },
        },
        format: {
          listViewSelector: {
            selector: {
              width: 1200,
            },
          },
        },
        alertIndication: {
          color: "#FF0000",
          backgroundColor: "#FFFF66",
        },
        noticeIndication: {
          color: "#000000",
          backgroundColor: "#FFFFCC",
        },
        header: {
          windowName : {
            windows: [],
          },
        },
      },
      routing: {
        unrestorableRouteExpressions: [],
      },
      system: {
        window: {
          opener: {
            features: "",
            locatorBasedOnFullScreen: {
              isEnable: false,
              rates: {
                top: 0.0,
                left: 0.0,
                width: 1.0,
                height: 1.0,
              },
            },
            offsets: {
              top: 0,
              left: 0,
              width: 0,
              height: 0,
            },
          },
          restorer: {
            isEnable: false,
            shouldStoreDb: false,
            label: "位置記憶",
            storedKeys: [],
            restorableMinimumSize: {
              width: 400,
              height: 300,
            },
            additonalRestoreDelayMilliSeconds: 0,
          },
          initializer: {
            isEnable: true,
            minimumSize: {
              width: 900,
              height: 800,
            },
            shouldResetLocationWhenResize: true,
          },
          manager: {
            shouldIgnoreQuitWhenLaunchedByHasValueAndMessageValueIsEmpty: false,
          },
        },
        notification: {
          position: "top-left",
        },
        date: {
          // デフォルト設定がマージされる前の動作なので、ここでは指定しない
          shouldOverwriteEras: null,
          // 元号定義.
          japaneseEras: [
            {
              name: "令和",
              shortName: "令",
              initial: "R",
              origin: {
                year: 2019,
                month: 5,
                day: 1,
              },
            },
            {
              name: "平成",
              shortName: "平",
              initial: "H",
              origin: {
                year: 1989,
                month: 1,
                day: 8,
              },
            },
            {
              name: "昭和",
              shortName: "昭",
              initial: "S",
              origin: {
                year: 1926,
                month: 12,
                day: 25,
              },
            },
            {
              name: "大正",
              shortName: "大",
              initial: "T",
              origin: {
                year: 1912,
                month: 7,
                day: 30,
              },
            },
            {
              name: "明治",
              shortName: "明",
              initial: "M",
              origin: {
                year: 1868,
                month: 1,
                day: 25,
              },
            },
          ],
          years: {
            count: {
              future: 100,
              past: 100,
            },
          }
        },
        dateSelector: {
          customButtons: [],
        },
        urlScheme: {
          beforeUnloadEventSetInterval: 50,
        },
        pdfRendering: {
          shouldRenderSelf: false,
          switchPdfViewer: false,
          accessorOption: {
            selectableTextLayer: true,
            isPDFSinglePageViewer: false,
            // 画像表示品質に影響。true時、縮小時の表示は綺麗だが拡大時にぼやける。IEで無駄に横スクロールバーが出てしまう制限あり
            useOnlyCssZoom: true,
            // 文字表示品質に影響。true時、IEのみ縮小時の表示が綺麗になる
            disableFontFace: true,
          },
          viewType: "",
        },
        help: {
          isEnable: false,
        }
      },
      wording: {
        document: {
          editor: {
            displayTextForCalculationError: "計算できませんでした",
            destinationNameForSendIndicator: "電子カルテ",
            hisInformationAlertAdditionalDescription: "その他の取得できた情報で文書編集を開始します。",
          },
          list: {
            status: {
              normal: "",
            }
          },
          note: "文書メモ",
        },
        common: {
          department: "診療科",
          departmentAsShort: "科",
          errorViewTitle: "システムエラー",
          errorViewDescription: "予期せぬエラーによって処理を中断しました。\r\n運用中に本画面が表示される場合は、システムの管理者に連絡してください。",
          departmentGroup: "診療科グループ"
        },
        format: {
          name: "フォーマット",
          attributes: {
            company: "会社",
            name: "文書",
            masterCode: "マスターコード"
          },
        },
      },
      debug: {
        // 開発者モードはlocalstorageに移動.
        // 開発中か？(開発者モードですら公開しないような開発中機能のスイッチとして利用してください.)
        isInDevelopment: true,
        // ログ出力.
        logger: {
          level: "DEBUG",
          consoleAppender: {
            isEnable: true,
            threshold: "DEBUG",
          },
          ajaxAppender: {
            isEnable: false,
            url: "http://localhost:8080/api/log",
            threshold: "INFO",
          },
        },
        shouldAlwaysShowObjectMenu: false,
        forceFormatHierarchiesEditable: false,
        forceDocumentFormatUpdatable: false,
      },
      dangerZone: {
        document: {
          factory: {
            shouldApplyValueForcibly: false,
          },
          editor: {
            printingWithoutRegistration: {
              shouldCloseWindowWhenForciblyEnabled: false,
              closeWaitTimeAsMsec: 3000,
            },
            fixedPhrase: {
              emptyRegistrationGuard: {
                isEnable: false,
                wording: "定型文を全て削除して登録する事はできません。"
              }
            },
            timeMeasurement: {
              objectSets: [],
            },
          }
        },
      },
    };
  }
}
